import { Component, OnChanges, SimpleChanges } from '@angular/core';
import { RegistrationRequestDto } from 'src/app/core/models/registration-request.model';
import { BaseListTableComponent } from '../base-list-table/base-list-table.component';
import { TranslocoService } from '@ngneat/transloco';
import { getRequestStatusIconName, getRequestStatusName, RegistrationRequestStatus } from 'src/app/core/models/registration-request-status';

@Component({
  selector: 'app-registrations-history-table',
  templateUrl: './registrations-history-table.component.html',
  styleUrls: ['./registrations-history-table.component.scss'],
})
export class RegistrationsHistoryTableComponent extends BaseListTableComponent<RegistrationRequestDto> implements OnChanges {
  displayedColumns: string[] = ['statusDate', 'statusName', 'reasonInfo', 'authorRoleName', 'authorName'];

  columnsNames = {
    statusDate: `Дата`,
    statusName: `Статус`,
    reasonInfo: `Причина`,
    authorRoleName: `Роль`,
    authorName: `Пользователь`,
  };

  MAX_DISPLAYED_NAME_LENGTH = 30;

  constructor(private translocoService: TranslocoService) {
    super();
  }

  override ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
  }

  getActiveLang() {
    return this.translocoService.getActiveLang();
  }

  /** Получить наименование класса иконки по статусу */
  getUserStatusIcon(status: RegistrationRequestStatus): string {
    return status ? getRequestStatusIconName(status) : '';
  }

  getStatusName(status: RegistrationRequestStatus): string {
    return getRequestStatusName(status ?? '', this.translocoService);
  }
}
